var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.666 7.115L10.794.986l.944.943L4.666 9 .424 4.757l.942-.942 3.3 3.3z"}));
}

CheckIcon.defaultProps = {"height":"9","fill":"#434856","viewBox":"0 0 12 9","width":"12"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
